module.exports = __webpack_public_path__ + "img/panel.69063d57.png";